// extracted by mini-css-extract-plugin
export default {"modalContent":"commonStyles_modalContent__FvGKQ","mutedText":"commonStyles_mutedText__5CaQh"};